import { Draft, produce } from 'immer';

import { AccountPasswordAction } from '@app/store/account/password/actions';
import {
  ACCOUNT_PASSWORD_FIND_FAILURE,
  ACCOUNT_PASSWORD_FIND_REQUEST,
  ACCOUNT_PASSWORD_FIND_SUCCESS,
  ACCOUNT_PASSWORD_RESET_FAILURE,
  ACCOUNT_PASSWORD_RESET_REQUEST,
  ACCOUNT_PASSWORD_RESET_SUCCESS,
} from '@app/store/actionTypes';

interface AccountPasswordState {
  isPasswordFinding: boolean;
  isPasswordReseting: boolean;
}

const initialState: AccountPasswordState = {
  isPasswordFinding: false,
  isPasswordReseting: false,
};

const reducer = produce((draft: Draft<AccountPasswordState>, action: AccountPasswordAction) => {
  switch (action.type) {
    case ACCOUNT_PASSWORD_FIND_REQUEST: {
      draft.isPasswordFinding = true;
      break;
    }
    case ACCOUNT_PASSWORD_FIND_SUCCESS:
    case ACCOUNT_PASSWORD_FIND_FAILURE: {
      draft.isPasswordFinding = false;
      break;
    }
    case ACCOUNT_PASSWORD_RESET_REQUEST: {
      draft.isPasswordReseting = true;
      break;
    }
    case ACCOUNT_PASSWORD_RESET_SUCCESS:
    case ACCOUNT_PASSWORD_RESET_FAILURE: {
      draft.isPasswordReseting = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default reducer;
